import React from 'react';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import CheckIcon from '@mui/icons-material/Check';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import { appLocales } from '../../i18n';

type AppLocale = (typeof appLocales)[number];

interface LanguageListProps {
  currentLocale: AppLocale;
  onLocaleSelect: (locale: AppLocale) => void;
}

const LanguageList: React.FC<LanguageListProps> = ({
  currentLocale,
  onLocaleSelect,
}) => {
  return (
    <List>
      {appLocales.map((appLocale) => (
        <ListItemButton
          onClick={() => onLocaleSelect(appLocale)}
          key={appLocale}
        >
          <ListItemText
            primary={<FormattedMessage {...messages[appLocale]} />}
          />
          {appLocale === currentLocale ? <CheckIcon /> : null}
        </ListItemButton>
      ))}
    </List>
  );
};

export default LanguageList;
